<template>
    <b-card no-body>
        <b-card-header
            header-tag="header"
            class="py-2 font-weight-bold text-uppercase"
        >
            <span>{{title}}</span> <span class="header-date">({{day.format('DD-MM-YYYY')}})</span>
        </b-card-header>
        <b-card-body>
            <b-row class="mb-3">
                <b-col cols="6" class="pending-block">
                    <div 
                        class="pending" 
                        :class="numberClassExcursion"
                    >
                        <span v-if="loading">
                            <i class="fa fa-spinner fa-spin"></i>
                        </span>
                        <span v-else>
                            {{pendingPaxExcursion}}
                        </span>
                    </div>
                    <span class="label">
                        PAX pendientes <br> (excursión)
                    </span>
                </b-col>
                <b-col cols="6" class="pending-block">
                    <div 
                        class="pending" 
                        :class="numberClassPickup"
                    >
                        <span v-if="loading">
                            <i class="fa fa-spinner fa-spin"></i>
                        </span>
                        <span v-else>
                            {{pendingPaxPickup}}
                        </span>
                    </div>
                    <span class="label">
                        PAX pendientes <br> (recogida)
                    </span>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" class="assigned-block">
                    <p>
                        {{totalPaxAssignedExcursion}}/{{totalPax}} PAX asignados (excursión)
                    </p>
                    <p>
                        {{totalPaxAssignedPickup}}/{{totalPax}} PAX asignados (recogida)
                    </p>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" class="text-right">
                    <span class="last-update">
                        Actualizado cada {{updateEvery/60}} minutos (+/- {{margin}} segundos). <br>Última actualización: {{lastUpdate.format('DD-MM-YYYY HH:mm:ss')}}.
                    </span>
                </b-col>
            </b-row>
            <!-- <b-row class="text-center mt-2">
                <b-col cols="12" class="text-right">
                    <router-link :to="anchor"
                        variant="light"
                        class="border py-1 px-3 button"
                    >
                        <span class="mr-2">Explorar</span>
                        <i class="fa fa-fw fa-caret-right"> </i>
                    </router-link>
                </b-col>
            </b-row> -->
        </b-card-body>
    </b-card>
</template>
<script>
/* eslint-disable */
import utils from '../../utils/utils'

export default {
    props: {
        title: {
            type: String,
            required: true,
        },
        day: {
            type: Object,
            required: true,
        },
        activity_group_id: {
            type: String,
            required: false,
            default: undefined
        },
        anchor: {
            type: String,
            required: true
        }
    },
    mixins: [utils],
    data() {
        return {
            loading: false,
            pendingPaxExcursion: 0,
            totalPaxAssignedExcursion: 0,
            pendingPaxPickup: 0,
            totalPaxAssignedPickup: 0,
            totalPax: 0,
            lastUpdate: this.$moment(),
            updateEvery: 120, // seconds
            margin: 2, // seconds,
            counterInterval: null
        }
    },
    mounted() {
        const sleepTime = Math.random() * (3000 - 500) + 500
        this.sleep(sleepTime)
        this.getData()
        const minInterval = (this.updateEvery*1000 - this.margin*1000)
        const maxInterval = (this.updateEvery*1000)
        this.counterInterval = setInterval(() => {
            this.getData()
            console.log('trigger in summaryitem')
        }, Math.random() * (maxInterval - minInterval) + minInterval )
        console.log(this.counterInterval, ' summaryitem')
        this.$once('hook:beforeDestroy', () => {
            console.log('clearinternval in hook2')
            clearInterval(this.counterInterval);
        })
    },
    beforeDestroy() {
        clearInterval( this.counterInterval )
    },  
    methods: {
        async getData() {
            console.log('trigger in summaryitem 22')
            this.loading = true
            const payload = {
                'day': this.day.format('YYYY-MM-DD')
            }
            const response = await this.$store.dispatch("dashboard/summaryDay", payload)
            this.totalPax = response.total
            this.pendingPaxExcursion = response.unassigned_excursion
            this.totalPaxAssignedExcursion = response.assigned_excursion
            this.pendingPaxPickup = response.unassigned_pickup
            this.totalPaxAssignedPickup = response.assigned_pickup
            this.loading = false
            this.lastUpdate = this.$moment()
        }
    },
    computed: {
        numberClassExcursion() {
            if ( !this.loading ) {
                if ( this.pendingPaxExcursion > 0 ) {
                    return 'non-zero'
                } else {
                    return 'zero'
                }
            }
            return ''
        },
        numberClassPickup() {
            if ( !this.loading ) {
                if ( this.pendingPaxPickup > 0 ) {
                    return 'non-zero'
                } else {
                    return 'zero'
                }
            }
            return ''
        }
    }
}
</script>

<style scoped>
.card-header {
    font-size: 1.1rem;
}
.pending {
    font-size: 4rem;
    font-weight: bold;
}
.pending.zero {
    color: rgb(39, 204, 39) !important;
}
.pending.non-zero {
    color: rgb(243, 23, 23);
}
.pending-block span.label {
    font-size: 1rem;
}
.assigned-block {
    font-size: 1rem;
}
.button {
    font-size: 1.1rem;
}
span.header-date {
    font-weight: normal;
    font-size: 1rem;
}
span.last-update {
    font-size: 9px;
}
</style>